import React, { memo } from 'react'
import { Box } from '@mui/material'
import { faIcons } from '@fortawesome/pro-light-svg-icons'

import { formatTransactionDisplayData } from '../../../util/transaction/transactionRow.helpers'
import TableCellData from '../DataTable/TableCellData'
import FaIcon from '../FaIcon/FaIcon'
import CustomTooltip from '../CustomTooltip/CustomTooltip'
import { formatTicks, truncateTextForHash } from '../../../util/string.helpers'
import { buildTxnStatusColorIcon } from '../../../util/transaction/transaction.helpers'
import StatusIcon from '../StatusIcon/StatusIcon'
import { NFT_DETAILS } from '../../../constants/nfts'
import Text from '../text/Text'

const TransactionDataRow = ({
  t,
  theme: { palette },
  showUserDetails,
  showTxnForExchange,
  ...restAttrs
}) => {
  const {
    date,
    exchangeCurrency,
    eventTypeLabel,
    pointAmount,
    exchangeAmount,
    statusLabel,
    statusGroup,
    eventTypeColor,
    user,
    txHash,
    additionalData
  } = formatTransactionDisplayData(restAttrs, showTxnForExchange)
  return (
    <>
      {showUserDetails && (
        <>
          <TableCellData textProps={{ color: '', fontWeight: 500 }}>
            {user?.firstName} {user?.secondName}
          </TableCellData>
          <TableCellData>{user?.email}</TableCellData>
          <TableCellData>
            <CustomTooltip label={user?.authId}>
              {truncateTextForHash(user?.authId)}
            </CustomTooltip>
          </TableCellData>
        </>
      )}
      <TableCellData align='center' noTag>
        <CustomTooltip label={t(statusLabel)}>
          <StatusIcon {...buildTxnStatusColorIcon(statusGroup)} />
        </CustomTooltip>
      </TableCellData>
      <TableCellData>{date}</TableCellData>
      <TableCellData>
        <CustomTooltip label={txHash}>
          {truncateTextForHash(txHash)}
        </CustomTooltip>
      </TableCellData>
      <TableCellData
        textProps={{ color: `${eventTypeColor}.main` }}
        wordBreak={false}
      >
        {t(eventTypeLabel)}
      </TableCellData>
      <TableCellData>
        {pointAmount && (
          <>
            <TransactionTypeIcon
              icon={pointAmount.icon}
              color={palette[pointAmount.color].main}
            />
            {formatTicks(pointAmount.value || 0)}
          </>
        )}
        {additionalData?.fees ? (
          <Text
            label={
              <>
                <strong>{t('common.fees')}: </strong>
                {formatTicks(additionalData?.fees)}
              </>
            }
            variant='caption'
            component='div'
          />
        ) : (
          ''
        )}
      </TableCellData>
      <TableCellData>
        {exchangeAmount && (
          <>
            <TransactionTypeIcon
              icon={exchangeAmount.icon}
              color={palette[exchangeAmount.color].main}
            />
            {formatTicks(exchangeAmount.value || 0)}
          </>
        )}
      </TableCellData>
      <TableCellData>
        <ExchangeCurrencyLabel exchangeCurrency={exchangeCurrency} />
      </TableCellData>
    </>
  )
}

export default memo(TransactionDataRow)

const TransactionTypeIcon = (props) => {
  return (
    <Box marginRight={0.5} display='inline-block'>
      <FaIcon {...props} width={18} />
    </Box>
  )
}

const ExchangeCurrencyLabel = ({ exchangeCurrency }) => {
  return exchangeCurrency === NFT_DETAILS.SYMBOL ? (
    <>
      <TransactionTypeIcon icon={faIcons} /> {exchangeCurrency}
    </>
  ) : (
    <>{exchangeCurrency}</>
  )
}
